import { useQuery } from '@tanstack/react-query';

import {
  DossierDtoAdminFonctionnel,
  DossierResponseDto,
} from 'lib_api/lib/api/gen';

import {
  ControllerApi,
  displayWarning,
  fetchCourrierNotificationResult,
  isInstanceOfAdminFonctionnel,
  SetDossierAdminF,
  SetDossierFo,
} from './utils';

export function useFetchCourrierNotification(
  controller: ControllerApi,
  dossierId: string,
  setDossier: SetDossierAdminF | SetDossierFo,
): fetchCourrierNotificationResult {
  const { refetch: refetchCourrierNotification } = useQuery({
    queryKey: ['fetchCourrierNotification', dossierId],
    queryFn: () => getFetchCourrierNotification(controller)(dossierId),
    enabled: false,
    retry: 0,
  });

  const fetchCourrierNotification = async () => {
    const result = await refetchCourrierNotification();
    if (result.isSuccess) {
      setDossier(
        result.data as DossierDtoAdminFonctionnel & DossierResponseDto,
      );
    } else if (result.isError) {
      displayWarning();
    }
  };

  return { fetchCourrierNotification };
}

function getFetchCourrierNotification(
  controller: ControllerApi,
): (id: string) => Promise<DossierDtoAdminFonctionnel | DossierResponseDto> {
  if (isInstanceOfAdminFonctionnel(controller)) {
    return controller.fetchCourrierUsingPOST1.bind(controller);
  }
  return controller.fetchCourrierUsingPOST.bind(controller);
}
